import {createReducer} from "./index";
import * as R from 'ramda';
import {
  ADD_USERS,
  API_GET_USER,
  API_GET_USER_QUERY,
  API_GET_USER_QUERY_DONE,
  API_GET_USER_QUERY_RESULTS
} from "../actions/users";
import moment from "moment";
import {createSelector} from "reselect/es"; // fix for Webstorm IDE code analysis

/*
Structure of the users model
{
  data: {
    [userid]: {
      resource: {
        id: string // uuid
        username: string
        firstname: string
        lastname: string
        middlename: string
        phone: string
        companyid: string // uuid
        title: string
        active: bool
        datecreated: datetime
        createdby: string // uuid
        datemodified: datetime
        modifiedby: string // uuid
        cell: string
        fax: string
        email: string
        userinitialized: bool
        companyadmin: bool
        acceptedtermsofservice: bool
        iscontactinfoprivate: bool
        iscontactinfofullyprivate: bool
        emailsettingbidinviteson: bool
        emailsettingprojectinviteson: bool
        emailsettingprebidon: bool
        emailsettingbiddueon: bool
        emailsettingprojectdueon: bool
        emailsettingbidactivityon: bool
        emailsettingprojectactivityon: bool
        emailsettingprojectdailylogon: bool
        isbidcreator: bool
        isprojectcreator: bool
        paytoplayprojectacknowledged: bool
        projectcreatorflagacknowledged: bool
        paytoplaybidacknowledged: bool
        bidcreatorflagacknowledged: bool
      }
      cache: {
        loading: bool
        fetched: datetime
        error: string
      }
    }
  }
  indexes: {
  }
}
 */

const addUsersToModel = (state, users) => {
  let newState = state;
  users.forEach(user => {
    let newData = {
      resource: user,
      cache: {
        loading: false,
        fetched: moment(),
        error: null,
      }
    };
    newState = R.set(R.lensPath(['data', user.id]), newData, newState);
  });
  return newState;
};

const userInitial = {
  data: {},
  indexes: {},
};

export const searchedUsers = createSelector(
  state => state.ui.userSearchResults,
  (resultIds) => resultIds.map(id => ({ contactuserid: id }))
);

const usersReducer = createReducer(userInitial,
  {
    [ADD_USERS]: (state, action) => {
      const { payload: users } = action;
      let newState = addUsersToModel(state, users);
      return newState;
    },
    // add a loading indicator
    [API_GET_USER]: (state, action) => {
      const { payload: { id }} = action;
      return R.pipe(
        R.set(R.lensPath(['data', id, 'cache', 'loading']), true),
        R.set(R.lensPath(['data', id, 'resource', 'id']), id)
      )(state);
    },
    [API_GET_USER_QUERY_RESULTS]: (state, action) => {
      const { results } = action.payload;
      return addUsersToModel(state, results);
    }
    // 'ACTION_NAME': function (state, action) -> new_state
  });

export default usersReducer;



// WEBPACK FOOTER //
// ./src/reducers/users.js